import type { Category, CategoryInput } from '@shop-monorepo/types';
import React from 'react';

import { useCreateCategory } from '../../hooks/useCategoryQueries';
import { useListReturn } from '../../hooks/useListReturn';
import { ROUTES } from '../../routes/routes';

import { CategoryForm } from './CategoryForm';

interface CreateCategoryFormProps {
  defaultParentId?: number;
  parentCategories: Category[];
}

export const CreateCategoryForm: React.FC<CreateCategoryFormProps> = ({
  defaultParentId,
  parentCategories,
}) => {
  const { goToList } = useListReturn(ROUTES.CATEGORIES);
  const { mutate: createCategory, isPending: isSubmitting } = useCreateCategory();

  const handleSubmit = async (values: CategoryInput) => {
    createCategory(values, {
      onSuccess: () => {
        goToList();
      },
    });
  };

  return (
    <CategoryForm
      initialValues={{ isActive: true, parentId: defaultParentId ?? null }}
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
      parentCategories={parentCategories}
    />
  );
};
